module.exports = __webpack_public_path__ + "assets/icon_docking_highlight.478b1e93.svg";